export default function Page(){
  return (
    <div className="page">
      <h1>Security Service 5</h1>
      <p>Dummy content for Security Service 5.</p>
      <img src="https://via.placeholder.com/800x300" alt="dummy"/>
    </div>
  );
}